import { fetchWrapper } from "@/helpers";
const ruta = process.env.VUE_APP_ROOT_API;

export default class BitacoraService {
  /* async obtenerListadoAgenda(data) {
    return await fetchWrapper.post(`${ruta}/agendas/listado`, data);
  } */
  async obtenerListadoAgenda(data) {
    // data ahora puede incluir fecha_inicio y fecha_fin
    return await fetchWrapper.post(`${ruta}/agendas/listado`, data);
  }

  async saveAgenda(datos) {
    return await fetchWrapper.post(`${ruta}/agendas/crear`, datos);
  }

  async updateAgenda(agenda) {
    return await fetchWrapper.put(`${ruta}/agendas/actualizar`, agenda);
  }

  /* async updatedCliente(cliente) {
    const clienteActualizado = await fetchWrapper.put(
      `${ruta}/cliente/` + cliente.id,
      cliente
    );
    return clienteActualizado;
  } */
  async deleteAgenda(id) {
    return await fetchWrapper.delete(`${ruta}/agendas/eliminar/${id}`);
  }

  async updateEstadoAgenda(id) {
    return await fetchWrapper.put(`${ruta}/agendas/actualizar_estado`, id);
  }

  async buscarAgendas(data) {
    return await fetchWrapper.post(`${ruta}/agendas/reporte`, data);
  }

  async enviarWhatsapp(data) {
    return await fetchWrapper.post(`${ruta}/agendas/enviarWhatsapp`, data);
  }

  async updateRecordatorio(data) {
    return await fetchWrapper.post(`${ruta}/agendas/recordatorio`, data);
  }

  async getDiasBloqueados() {
    return await fetchWrapper.get(`${ruta}/agendas/dias_bloqueados`);
  }

  async bloquearDia(data) {
    return await fetchWrapper.post(`${ruta}/agendas/bloquear_dia`, data);
  }

  async desbloquearDia(data) {
    return await fetchWrapper.post(`${ruta}/agendas/desbloquear_dia`, data);
  }
}
